<template lang="pug">
  .cart
    FixedWidthContainer
      .header-wrap.xs-12.xs-text-center.lg-text-left.xs-pt-50m.xs-pb-50m
        h2.upper.xs-f-xmedium.max-at-tweak
          span.icon-bag
          | &nbsp;shopping bag

        button.transparent-btn.back-x.xs-f-xmedium.max-at-tweak.lg-hide(@click="back")
          span.icon-x
            span.ada-tooltip back

    div(v-if="!cart.statusCode && loadingCart")
      .cart-spinner
        MrSpinner

    template(v-else)
      template(v-if="!cart.items || !cart.items.length")
        FixedWidthContainer
          .empty-cart.xs-12.text-center.xs-pt-500m.xs-pr-500m.xs-pb-500m.xs-pl-500m
            p.header.xs-f-large.light.mb-20 your bag is empty
            a(href='/').mr-btn.btn-medium keep shopping
         
      template(v-else)
        button.cart-email-capture-banner.transparent-btn.text-bar.xs-12.text-center.xs-mb-150m(v-if="showEmailCaptureBanner" @click="showEmailCaptureModal" data-mr-ass="email-capture")
          span.color-purple.xs-f-xsmall.sm-f-small.md-f-medium.max-at-tweak Click here for FREE SHIPPING on your first order

        FixedWidthContainer
          .cart-contents.xs-mb-250m.xs-12
            .cart-items.xs-12.sm-6.md-7.lg-8.md-pr-175m.lg-pr-175m
              transition-group.xs-12(name="fade" tag="div")
                CartItem.xs-12(v-for="item in cart.items" :item="item" :key="item.index + item.id + '-prod'")

            .cart-subscription-benefits.xs-12.lg-8
              CartMembershipProgram
              CartSubscribeAndSave

            .cart-totals.xs-12.sm-6.md-5.lg-4
              CartTotals

    FixedWidthContainer(v-if="showRefillCart")
      CartRefillCart

    FixedWidthContainer(v-if="cart && cart.addons && cart.addons.length")
      .cart-xsell.xs-pb-150m.xs-12
        .cart-xsell-title.xs-12.xs-mb-150m
          h3.upper.xs-f-xmedium.max-at-tweak(data-mr-ass="cross-sell-header") Recommended for you:
        .cart-xsell-items.xs-12(data-mr-ass="cross-sell-products")
          CartXsellItem(v-for="(item, index) in cart.addons" :key="item.id + '-xsell'" :item="item" :index="index")

</template>

<script>
  import { mapState, mapActions, mapGetters } from "vuex";

  export default {
    name: "Cart",
    components: {
      MrSpinner: () => import("../MrSpinner"),
      CartXsellItem: () => import("./CartXsellItem"),
      CartRefillCart: () => import("./CartRefillCart"),
      CartTotals: () => import("./CartTotals"),
      CartSubscribeAndSave: () => import("./CartSubscribeAndSave"),
      CartMembershipProgram: () => import("./CartMembershipProgram"),
      CartItem: () => import("./CartItem"),
      FixedWidthContainer: () => import("../FixedWidthContainer")
    },

    inject: ['getObjProperty'],

    computed: {
      ...mapState('cart', ['cart', 'cartUpdated']),
      ...mapState('customer', ['cdata']),

    },

    computed: {
      ...mapState('cart', [
        'cart',
        'cartInitialized',
        'loadingCart'
      ]),
      ...mapState('customer', ['cdata']),
      ...mapState('refillCart', ['refillCart']),
      ...mapGetters('refillCart', ['refillCartItems']),
      ...mapGetters('cart', ['appliedPromoByType']),
      ...mapGetters('customer', ['visitorType']),

      showRefillCart() {
        return this.refillCartItems.length;
      },

      showEmailCaptureBanner() {
        return this.visitorType !== 'return buyer' && !this.appliedPromoByType('freeShipping');
      }
    },

    methods: {
      ...mapActions('cart', ['loadCart']),
      ...mapActions('modal', ['showModal']),
      ...mapActions('refillCart', ['initRefillCart']),

      showEmailCaptureModal() {
        this.showModal({ component: './Cart/CartEmailCaptureModal' });
      }

    },

    beforeMount() {
      if (!this.cartInitialized) {
        this.loadCart();
      }
      this.initRefillCart();
    }
  }
</script>

<style scoped lang="stylus">
  .cart
    .header-wrap
      padding 1em 3%
      padding-bottom 1.5em
      
      .icon-bag
        &:before
          margin-left 0
          
      .back-x
        position absolute
        top 0
        right 0
        padding 0.5em
        color color-gray-med
        background transparent
        border none
      
    .cart-spinner
      padding 10%

    .cart-email-capture-banner
      z-index 1
      background-color rgba(color-mr-blue, 0.3)
      padding 1em 3%
      height 100%

    .cart-contents
      padding 0 3%
      display flex
      flex-direction row
      flex-wrap wrap
      
    .cart-xsell
      .cart-xsell-title
        padding 0 3%
        
      .cart-xsell-items
        padding 0 2%
        
    @media mq-mobile
      .header-wrap
        padding 1em 5%
        padding-bottom 1.5em
        
      .cart-xsell
        .cart-xsell-title
        .cart-xsell-items
          padding 0 5%
          
    @media mq-tablet
      .cart-subscription-benefits
        width 100%
        order 1

    @media mq-desktop-md
      .cart-subscription-benefits
        width 100%
        order 1

  @media mq-desktop-plus
    .cart-contents
      display grid !important
      grid-template-columns repeat(12, 1fr)

      .cart-items
        grid-column 1 / 9
        grid-row 1
        width 100%

      .cart-totals
        grid-column 9 / 13
        grid-row 1 /  3
        width 100%
      
      .cart-subscription-benefits
        order 1
        padding-right 1.75em
        grid-column 1 / 9
        grid-row 2
        width 100%
        display flex
        align-items flex-end

</style>
